function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 1.178L8.822 0 5 3.822 1.178 0 0 1.178 3.822 5 0 8.822 1.178 10 5 6.178 8.822 10 10 8.822 6.178 5 10 1.178z",
  fill: "#000"
});

function SvgClose(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDEuMTc4MzhMOC44MjE2MiAwTDQuOTk5OTkgMy44MjE2MUwxLjE3ODM4IDBMMCAxLjE3ODM4TDMuODIxNjEgNC45OTk5OUwwIDguODIxNjJMMS4xNzgzOCAxMEw0Ljk5OTk5IDYuMTc4MzlMOC44MjE2IDEwTDkuOTk5OTcgOC44MjE2Mkw2LjE3ODM5IDQuOTk5OTlMMTAgMS4xNzgzOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };